var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSignOut = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.072 2.691 3.123 3.123c.178.178.305.432.305.686 0 .28-.127.533-.305.71l-3.123 3.124a.865.865 0 0 1-.61.229.845.845 0 0 1-.837-.838v-1.6h-3.25a.802.802 0 0 1-.813-.813V5.688c0-.431.356-.812.813-.812h3.25V3.301c0-.457.38-.864.838-.864.228 0 .457.102.61.254Zm-5.51-.253H2.938a.818.818 0 0 0-.812.812v6.5c0 .457.355.813.813.813h1.624c.432 0 .813.38.813.812 0 .457-.38.813-.813.813H2.938A2.438 2.438 0 0 1 .5 9.75v-6.5A2.438 2.438 0 0 1 2.938.812h1.624c.432 0 .813.381.813.813 0 .457-.38.813-.813.813Z",
    fill: "#fff"
  })));
};
export default SvgSignOut;